import React, { Component } from 'react'
import { connect } from 'react-redux'
import { removeRadarWidget } from 'actions/widget/index.js'
import { FOOTBALL, ICE_HOCKEY, BASKETBALL } from 'constants/SportType'

function isAvailableStreamSport(sportId){
  return [ FOOTBALL, ICE_HOCKEY, BASKETBALL ].includes(sportId)
}

class BetradarWidget extends Component {
  state = {
    streamURL: null,
  }

  componentDidMount = () => {
    const { activeWidgetId, activeWidgetSportId } = this.props
    this.checkStreamStatus()
    window.radarWidget.start(activeWidgetId, activeWidgetSportId)
  }

  componentDidUpdate = (prevProps) => {
    const { gamblerId, streamURL, activeWidgetId, activeWidgetSportId } = this.props
    if (
      prevProps.activeWidgetId !== activeWidgetId ||
      prevProps.streamURL !== streamURL ||
      prevProps.gamblerId !== gamblerId
    ) {
      this.checkStreamStatus()
      window.radarWidget.start(activeWidgetId, activeWidgetSportId)
    }
  }

  checkStreamStatus = () => {
    const {activeWidgetId, activeWidgetSportId, gamblerId, balance} = this.props

    if(isAvailableStreamSport(activeWidgetSportId) && gamblerId && balance > 0) {
      fetch(`/api/betradar/?radarId=${activeWidgetId}`)
        .then((r) => r.json())
        .then((streamURL) => {
          if (streamURL) {
            this.setState({ streamURL })
          } else {
            this.setState({ streamURL: '' })
          }
        })
    } else {
      this.setState({ streamURL: '' })
    }
  }

  openPlayerWindow = () => {
    this.closePlayerWindow()
    const windowWidth = window.screen.width || window.innerWidth

    const streamWidth = windowWidth / 2
    const streamHeight = streamWidth / 1.78
    
    this.windowPlayer = window.open(
      `/sportradar-stream.html?name=${this.props.name}&radarId=${this.props.activeWidgetId}&width=${streamWidth}&height=${streamHeight}`,
      this.props.name,
      `width=${streamWidth},height=${streamHeight},resize=no`
    );
  }

  closePlayerWindow = () => {
    if(this.windowPlayer) {
      this.windowPlayer.close()
      delete this.windowPlayer
    }
  }

  render() {
    const { streamURL } = this.state
    const { name, activeWidgetId } = this.props

    return (
      <div>
        <div className="widget-container">
          <div className="widget-container__header">
            <span className="name">{name}</span>
            {streamURL && <div className="toggle-btn" onClick={this.openPlayerWindow} />}
            <div className="close-btn" onClick={() => {
              this.closePlayerWindow()
              this.props.removeRadarWidget()
            }} />
          </div>

          <div key={activeWidgetId} className="match-widget" />
        </div>
      </div>
    )
  }
}

const withBetradarHOC = (Component) => (props) => {
  if (props.activeWidgetId) {
    return <Component {...props} />
  }
  return null
}

function mapStateToProps(state) {
  const user = state.auth.get('user')
  const balance = state.balance.get('value')
  const gamblerId = user ? user.get('gamblerId') : false
  
  return {
    ...state.application.get('betradar'),
    gamblerId,
    balance,
  }
}

export default connect(mapStateToProps, { removeRadarWidget })(
  withBetradarHOC(BetradarWidget)
)



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/Stream/BetradarWidget.jsx